import React, { useEffect, useMemo, useState, useContext, useRef } from "react";
import { LassieContext } from "../../../context/LassieProvider";
import { useParams } from "react-router-dom";
import { createPortal } from 'react-dom';
import { lassieTriggerAPI, lightningScenarioAPI } from '../../../api'
import { useSyncSelectedWindfarm } from "../../../hooks/useSyncSelectedWindfarm";
import AlertPopup from "../../../components/alert-popup/AlertPopup";
import WPLAnimatedInput from "../../../components/wpl-animated-input/WplAnimatedInput";
import CenteredPopup from "../../../components/centered-popup/CenteredPopup";
import notificationIcon from "../../../assets/notification.png";
import newTriggerIcon from "../../../assets/plus.png";
import WplButton from "../../../components/wpl-button/WplButton";
import WplSwitch from "../../../components/wpl-switch/wplSwitch";
import TurbineAnimation from "../../../components/turbine-animation/TurbineAnimation";
import OptionsMenu from "../../../components/options-menu/OptionsMenu";
import CustomTriggerForm from "../../../components/custom-trigger-form/CustomTriggerForm";
import TriggerCard from "../../../components/trigger-card/TriggerCard";
import ActionConditionCard from "../../../components/action-condition-card/ActionConditionCard";
import WplSelectInput from "../../../components/wpl-select-input/WplSelectInput";
import infoIcon from "../../../assets/img/map-info.png";
import optionIcon from "../../../assets/img/option-icon.png";
import optionIconWhite from "../../../assets/img/option-icon-white.png";
import editIconGray from '../../../assets/img/edit-gray.png';
import deleteIconGray from '../../../assets/img/delete-gray.png';
import "./lightning-wf-notification-settings.css";

export default function LightningWfNotificationSettings() {
  const {
    windfarms,
    notificationsOverview,
    updateScenarioStatus,
    settingsLoading,
    setSettingsLoading,
    fetchScenariosOverview,
    fetchTurbineModels,
    turbineModels,
    notificationUpdate,
    fetchOrganizations,
    getInspectionTemplates,
    organization,
    inspectionTemplates, editMode, setEditMode
  } = useContext(LassieContext);

  const scenarioRef = useRef({});
  const triggerRef = useRef({})
  const [showPopup, setShowPopup] = useState({
    state: false,
    type: "",
    scenario_id: null,
    trigger_exists: false,
  });
  const [scenarios, setScenarios] = useState([]);
  const [scenarioTitle, setScenarioTitle] = useState("");
  const [scenarioDescription, setScenarioDescription] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [updatingScenarioId, setUpdatingScenarioId] = useState(null);
  const [triggers, setTriggers] = useState({
    inside: {
      trigger_type: "inside-cert",
      min_probability: 9,
      max_distance_km: null,
    },
    outside: {
      trigger_type: "outside-cert",
      min_probability: 9,
      max_distance_km: null,
    },
    custom: {
      is_subsequent: false,
      min_peak_current: null,
      max_peak_current: null,
      min_probability: null,
      max_distance_km: null,
      turbine_models: []
    },
  });
  const [selectedActionTrigger, setSelectedActionTrigger] = useState('');
  const [notificationPopup, setNotificationPopup] = useState({
    show: false,
    status: '',
    title: '',
    buttonText: '',
    buttonStatus: '',
    text: '',
    action: null,
    buttonText2: '',
    buttonStatus2: '',
    action2: null,

  })

  const [showScenarioId, setShowScenarioId] = useState(null)
  const [showTriggerId, setShowTriggerId] = useState({ id: null, type: null });
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  let { windfarm_id } = useParams();
  if (windfarm_id) {
    windfarm_id = parseInt(windfarm_id);
  }

  const windfarm = useMemo(() => {
    if (!windfarms || !windfarm_id) return null;
    return windfarms.find((wf) => wf.id === parseInt(windfarm_id));
  }, [windfarms, windfarm_id]);

  useEffect(() => {
    fetchOrganizations()
  }, [])

  useEffect(() => {
    if (!organization || !organization.id) return;
    getInspectionTemplates(organization.id);
  }, [organization]);

  useEffect(() => {
    if (!notificationsOverview[windfarm_id]) {
      fetchScenariosOverview(windfarm_id);
    }
  }, [notificationsOverview])

  useEffect(() => {
    fetchScenarios(windfarm_id);
    fetchTurbineModels(windfarm_id)
  }, [windfarm_id]);

  const fetchScenarios = async () => {
    try {
      const scenariosData =
        await lightningScenarioAPI.list_scenarios_by_windfarm_id(windfarm_id);
      setScenarios(scenariosData);
    } catch (error) {
      console.log(error);
    }
  };

  const createScenario = async (scenarioTitle, scenarioDescription) => {
    const immediate_action = "";
    setSettingsLoading(true);
    try {
      const values = {
        title: scenarioTitle,
        immediate_action,
        description: scenarioDescription,
        windfarm_id,
      };

      await lightningScenarioAPI.create_scenario(values);
    } catch (error) {
      console.log(error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      initializeScenario();
    }
  };

  const createCustomTrigger = async () => {
    const custom = triggers.custom;
    const turbineModels = custom.turbine_models.length
      ? custom.turbine_models
      : [null];

    const values = selectedCard === "custom" && {
      ...triggers.custom,
      min_probability:
        triggers.custom.min_probability === 0 ||
          triggers.custom.min_probability == null
          ? null
          : triggers.custom.min_probability / 100,
      max_distance_km:
        triggers.custom.max_distance_km === 0 ||
          triggers.custom.max_distance_km == null
          ? null
          : triggers.custom.max_distance_km / 1000,
    };

    setSettingsLoading(true);
    try {
      for (const turbineModel of turbineModels) {
        const valuesWithModel = {
          ...values,
          turbine_model: turbineModel,
        };
        await lassieTriggerAPI.create_scenario_trigger(
          showPopup.scenario_id,
          valuesWithModel
        );
      }
    } catch (error) {
      console.log("There was an error creating a custom trigger: " + error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      initializeScenario();
    }
  };

  const createPredefinedTrigger = async () => {
    let values;
    if (selectedCard === "inside") {
      values = {
        ...triggers.inside,
        trigger_type: triggers.inside.trigger_type,
        min_probability:
          !triggers.inside.min_probability && triggers.inside.min_probability !== 0
            ? null
            : triggers.inside.min_probability / 100,
        max_distance_km:
          !triggers.inside.max_distance_km && triggers.inside.max_distance_km !== 0
            ? null
            : triggers.inside.max_distance_km / 1000,
      };
    } else if (selectedCard === "outside") {
      values = {
        ...triggers.outside,
        trigger_type: triggers.outside.trigger_type,
        min_probability:
          !triggers.outside.min_probability && triggers.outside.min_probability !== 0
            ? null
            : triggers.outside.min_probability / 100,
        max_distance_km:
          !triggers.outside.max_distance_km && triggers.outside.max_distance_km !== 0
            ? null
            : triggers.outside.max_distance_km / 1000,
      };
    } else {
      values = null;
    }

    setSettingsLoading(true);

    try {
      await lassieTriggerAPI.create_scenario_predefined_trigger(
        showPopup.scenario_id,
        values
      );
    } catch (error) {
      console.log("There was an error creating a predefined trigger: " + error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      initializeScenario();
    }
  };

  const handleCreateActionCondition = async (scenario_id, action_type) => {
    setSettingsLoading(true);

    const triggerTypeLabels = {
      data_upload: "uploaded attachment",
      marked_for_repair: "marked for repair",
      inspection_scheduled: "inspection scheduled"
    };

    if (checkMaxActionTriggers(scenarios, scenario_id, action_type)) {
      const label = triggerTypeLabels[action_type] || action_type;
      setShowPopup({ state: false, type: "", scenario_id: null, trigger_exists: false });
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Trigger already exists',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: `A trigger for "${label}" already exists in this scenario.`
      });
      setSettingsLoading(false);
      return;
    }

    try {
      await lassieTriggerAPI.createActionCondition(scenario_id, action_type);
    } catch (error) {
      console.log("There was an error creating an action condition: " + error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      initializeScenario();
    }
  };

  const handleUpdateActionCondition = async (conditionId, action_type) => {
    setUpdatingScenarioId(conditionId);
    try {
      const res = await lassieTriggerAPI.updateActionCondition(conditionId, action_type);
      setScenarios(prev =>
        prev.map(scenario => ({
          ...scenario,
          action_conditions: scenario.action_conditions.map(condition =>
            condition.id === conditionId
              ? { ...condition, ...res }
              : condition
          )
        }))
      );
    } catch (error) {
      console.error("Error updating action condition:", error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      setUpdatingScenarioId(null);
    }
  }


  const handleUpdateTemplateId = async (scenario_id, template_id) => {
    try {
      await lightningScenarioAPI.updateTemplateId(scenario_id, template_id)
    } catch (error) {
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    }
  }

  const handleUpdateScenario = async (scenario_id, title, description) => {
    setUpdatingScenarioId(scenario_id);
    try {
      const res = await lightningScenarioAPI.updateScenario(scenario_id, title, description)
      if (res) {
        setScenarios(prev =>
          prev.map(s =>
            s.scenario_id === scenario_id
              ? { ...s, title, description }
              : s
          )
        );
      }
    } catch (error) {
      console.log("There was an error updating the scenario: " + error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    }
    finally {
      setUpdatingScenarioId(null);
      setEditMode({ id: null, status: false })
    }
  }

  const handleDeleteScenario = async (scenario_id) => {
    setSettingsLoading(true);
    try {
      const res = await lightningScenarioAPI.deactivate_scenario(scenario_id)
      if (res === 'OK') {
        setScenarios(prev => prev.filter(s => s.scenario_id !== scenario_id));
      }
    } catch (error) {
      console.log("There was an error deleting the scenario: " + error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      setSettingsLoading(false);
    }
  }


  const handleDeleteTrigger = async ({ id, type }) => {
    setUpdatingScenarioId(id);

    try {
      const apiCall =
        type === 'lightning'
          ? lassieTriggerAPI.deleteLightningTrigger
          : lassieTriggerAPI.deleteActionTrigger;

      const res = await apiCall(id);

      if (res === 'OK') {
        setScenarios(prev =>
          prev.map(scenario => {
            const key = type === 'lightning' ? 'triggers' : 'action_conditions';
            if (scenario[key].some(item => item.id === id)) {
              return {
                ...scenario,
                [key]: scenario[key].filter(item => item.id !== id),
              };
            }
            return scenario;
          })
        );
      }
    } catch (error) {
      console.error(`Error deleting ${type} trigger:`, error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      setUpdatingScenarioId(null);
    }
  };


  const handleCreateTrigger = () => {
    if (selectedCard === "custom") {
      createCustomTrigger();
    } else {
      createPredefinedTrigger();
    }
  };

  const handleCardClick = (title) => {
    setSelectedCard(title);
  };

  const handleInputChange = (e) => {
    const { name, value, id } = e.target;

    setTriggers((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }));
  };

  const initializeScenario = () => {
    setShowPopup({
      state: false,
      type: "",
      scenario_id: null,
      trigger_exists: false,
    });

    fetchScenarios();
    fetchScenariosOverview(windfarm_id);
    setSettingsLoading(false);

    setScenarioTitle("");
    setScenarioDescription("");

    setTriggers((prevTriggers) => ({
      ...prevTriggers,
      inside: {
        trigger_type: "inside-cert",
        min_probability: 9,
        max_distance_km: null,
      },
      outside: {
        trigger_type: "outside-cert",
        min_probability: 9,
        max_distance_km: null,
      },
      custom: {
        is_subsequent: false,
        min_peak_current: null,
        max_peak_current: null,
        min_probability: null,
        max_distance_km: null,
        turbine_models: [],
      },
    }));
  };

  const handleClosePopup = () => {
    setShowPopup({
      state: false,
      type: "",
      scenario_id: null,
      trigger_exists: false,
    });
    setTriggers({
      inside: {
        trigger_type: "inside-cert",
        min_probability: 9,
        max_distance_km: null,
      },
      outside: {
        trigger_type: "outside-cert",
        min_probability: 9,
        max_distance_km: null,
      },
      custom: {
        is_subsequent: false,
        min_peak_current: null,
        max_peak_current: null,
        min_probability: null,
        max_distance_km: null,
        turbine_models: [],
      },
    });
  };

  const handleTemplateChange = async (selectedId, scenario) => {
    const newTemplateId = selectedId === '' ? null : Number(selectedId);
    setUpdatingScenarioId(scenario.scenario_id);
    try {
      await handleUpdateTemplateId(scenario.scenario_id, newTemplateId);
      setScenarios(prev =>
        prev.map(s =>
          s.scenario_id === scenario.scenario_id
            ? { ...s, inspection_template_id: newTemplateId }
            : s
        )
      );
    } catch (error) {
      console.log('Error updating inspection template ID for scenario');
    } finally {
      setUpdatingScenarioId(null);
    }
  };


  const handleUpdateTrigger = async (triggerId, values) => {
    setUpdatingScenarioId(triggerId);
    try {
      const res = await lassieTriggerAPI.update_trigger(triggerId, values);
      setScenarios(prev =>
        prev.map(scenario => ({
          ...scenario,
          triggers: scenario.triggers.map(trigger =>
            trigger.id === triggerId
              ? { ...trigger, ...res }
              : trigger
          )
        }))
      );

    } catch (error) {
      console.error("Error updating trigger:", error);
      setNotificationPopup({
        show: true,
        status: 'wrong',
        title: 'Something went wrong',
        buttonText: 'Close',
        buttonStatus: 'wrong',
        text: error.response?.data
      });
    } finally {
      setUpdatingScenarioId(null);
    }
  }

  const resetScenario = () => {
    setScenarioTitle("")
    setScenarioDescription("")
  }


  const checkMaxActionTriggers = (scenario, scenario_id, action_type) => {
    const selectedScenario = scenario.find(s => s.scenario_id === scenario_id);
    if (!selectedScenario) return false;

    const alreadyExists = selectedScenario.action_conditions.some(
      (ac) => ac.action_type === action_type
    );

    return alreadyExists;
  };

  const isEmpty = (v) =>
    v === null ||
    v === undefined ||
    (typeof v === "string" && v.trim() === "") ||
    (typeof v === "number" && Number.isNaN(v));


  useSyncSelectedWindfarm(windfarm_id);

  return (
    <div className="wf-notifications-container">
      <div>
        <p className="disclaimer-container">
          <b>Important:</b> Please note that changing these parameters may
          affect the application’s performance and the notifications being sent.
        </p>
      </div>
      <h2>{windfarm && windfarm.name}</h2>
      {settingsLoading ? (
        <div className="overlay loading">
          <TurbineAnimation />
        </div>
      ) : (
        <div>
          <div className="btn-container">
            <WplButton
              onClick={() => { setShowPopup({ state: true, type: "scenario" }); resetScenario() }}
              className="settings-btn"
              value="Create a new notification"
            />
          </div>

          <div className="cards-area">
            {scenarios &&
              scenarios.map((s) => {
                if (!s.title) return null;
                return (
                  <div key={s.scenario_id} className="scenario-card">
                    <div className="title-area">
                      <div className="title-header">
                        <img
                          src={notificationIcon}
                          className="card-icon"
                          alt="icon"
                        />
                        {editMode.status && editMode.id === s.scenario_id ?
                          <div className={`scenario-title-input-container ${updatingScenarioId === s.scenario_id ? 'updating-row' : ''}`}>
                            <input
                              className="scenario-title-input"
                              label="Scenario title"
                              type="text"
                              name="scenarioTitle"
                              value={editMode.id === s.scenario_id ? scenarioTitle : s.title}
                              onChange={(e) => setScenarioTitle(e.target.value)}
                            />
                            <div className='comment-action-container'>
                              <button className='org-btn cancel-btn'
                                disabled={updatingScenarioId === s.scenario_id}
                                onClick={() => setEditMode({ id: null, status: false })}
                              >X
                              </button>
                              <button className='org-btn success-btn'
                                disabled={updatingScenarioId === s.scenario_id || scenarioTitle === "" || scenarioDescription === ""}
                                onClick={() => handleUpdateScenario(s.scenario_id, scenarioTitle, scenarioDescription)}
                              >✔
                              </button>
                            </div>
                          </div> :
                          <h4 className="scenario-title">{s.title}</h4>
                        }
                      </div>

                      <div
                        className='option-cell'
                        onClick={() => {
                          if (updatingScenarioId) return;
                          const icon = scenarioRef.current[s.scenario_id];
                          if (icon) {
                            const rect = icon.getBoundingClientRect();
                            setMenuPosition({
                              top: rect.bottom + window.scrollY,
                              left: rect.left + window.scrollX + 15,
                            });
                            setShowScenarioId(showScenarioId === s.scenario_id ? null : s.scenario_id);
                          }
                        }}>
                        <img
                          src={optionIconWhite}
                          className='action-icon option-btn'
                          ref={(el) => (scenarioRef.current[s.scenario_id] = el)}
                        />
                      </div>

                    </div>
                    {s.description && (
                      <div className="description-area">
                        <p className="description-label">Description: </p>
                        {editMode.status && editMode.id === s.scenario_id ?
                          <input
                            className={`scenario-description-input ${updatingScenarioId === s.scenario_id ? 'updating-row' : ''}`}
                            label="Scenario description"
                            type="text"
                            name="scenarioDescription"
                            value={editMode.id === s.scenario_id ? scenarioDescription : s.description}
                            onChange={(e) => setScenarioDescription(e.target.value)}
                          />
                          : <p className="despcription">{s.description}</p>}
                      </div>
                    )}
                    {notificationsOverview[windfarm_id] &&
                      notificationsOverview[windfarm_id].map((n) =>
                        n.scenario_id === s.scenario_id ? (
                          <div key={n.scenario_id}
                            className={notificationUpdate.id === n.scenario_id ? 'notification updating-row' : 'notification'}
                          >
                            <p>
                              {n.isSubscribed ? "Disable " : "Enable "}
                              notifications
                            </p>
                            <WplSwitch
                              value={n.isSubscribed}
                              onChanged={() =>
                                updateScenarioStatus(n, windfarm_id)
                              }
                            />
                          </div>
                        ) : null
                      )}
                    {
                      inspectionTemplates && (
                        <div className="template-selector-wrapper">
                          <p className="trigger-value">
                            Select an inspection template to associate with this scenario
                          </p>
                          <select
                            className={`${updatingScenarioId === s.scenario_id ? 'updating-row' : ''
                              }`}
                            value={s.inspection_template_id ?? ''}
                            onChange={(e) => handleTemplateChange(e.target.value, s)}
                          >
                            <option value="">No template</option>
                            {inspectionTemplates.map((template) =>
                              template.due_in_hours !== null ? (
                                <option key={template.id} value={template.id}>
                                  {template.title}
                                </option>
                              ) : null
                            )}
                          </select>
                        </div>
                      )
                    }

                    <div className="content">
                      <div className="lightning-scenario-area">
                        <div className="triggers-header">
                          <h4>Lightning triggers</h4>
                          <div className="new-trigger-btn">
                            <img
                              src={newTriggerIcon}
                              className="new-trigger-icon"
                              alt="Add a new lightning trigger"
                              onClick={() => {
                                setSelectedCard(null)
                                setShowPopup({
                                  state: true,
                                  type: "lightning-trigger",
                                  scenario_id: s.scenario_id,
                                  currentTriggers: s.triggers,
                                  trigger_exists: s.trigger_exists,
                                })
                              }
                              }
                            ></img>
                          </div>
                        </div>

                        <div className="lightning-triggers-area">
                          {s.triggers &&
                            s.triggers.map(
                              (t, i) =>
                                t.id !== null && (
                                  <TriggerCard
                                    key={t.id}
                                    trigger={t}
                                    onUpdate={handleUpdateTrigger}
                                    onDelete={() => handleDeleteTrigger({ id: t.id, type: 'lightning' })}
                                    turbineModels={turbineModels}
                                    isUpdating={updatingScenarioId === t.id}
                                    isEditing={editMode.id === t.id && editMode.status}
                                    onEditToggle={() => setEditMode(editMode.id === t.id ? { id: null, status: false } : { id: t.id, status: true })}
                                    onOptionMenuToggle={(triggerId, type, position) => {
                                      setMenuPosition(position);
                                      setShowTriggerId({ id: triggerId, type: type });
                                    }}
                                  />
                                )
                            )}
                        </div>
                      </div>
                      <div className="action-scenario-area">
                        <div className="triggers-header">
                          <h4>Action triggers</h4>
                          <div className="new-trigger-btn">
                            <img
                              src={newTriggerIcon}
                              alt="Add a new action trigger"
                              className="new-trigger-icon"
                              onClick={() => {
                                setSelectedActionTrigger('');
                                setShowPopup({
                                  state: true,
                                  type: "action-trigger",
                                  scenario_id: s.scenario_id,
                                  currentTriggers: s.triggers,
                                  trigger_exists: s.trigger_exists,
                                })
                              }
                              }
                            ></img>
                          </div>
                        </div>
                        <div className="lightning-triggers-area">
                          {s.action_conditions &&
                            s.action_conditions.map(
                              (a, i) =>
                                a.id !== null && (
                                  <ActionConditionCard
                                    key={a.id}
                                    condition={a}
                                    onUpdate={handleUpdateActionCondition}
                                    onDelete={() => handleDeleteTrigger({ id: a.id, type: 'action' })}
                                    isUpdating={updatingScenarioId === a.id}
                                    isEditing={editMode.id === a.id && editMode.status}
                                    onEditToggle={() => setEditMode(editMode.id === a.id ? { id: null, status: false } : { id: a.id, status: true })}
                                    onOptionMenuToggle={(conditionId, type, position) => {
                                      setMenuPosition(position);
                                      setShowTriggerId({ id: conditionId, type: type });
                                    }}
                                  />
                                )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          {showScenarioId && createPortal(
            <div
              className="options-container"
              style={{
                position: 'absolute',
                top: menuPosition.top,
                left: menuPosition.left,
                zIndex: 9999,
              }}
            >
              <OptionsMenu
                options={[
                  {
                    label: 'Edit scenario',
                    onClick: () => {
                      const selectedScenario = scenarios.find(s => s.scenario_id === showScenarioId);
                      resetScenario()
                      setScenarioTitle(selectedScenario.title);
                      setScenarioDescription(selectedScenario.description);
                      setEditMode({ id: showScenarioId, status: true });
                    },
                    img: editIconGray
                  },
                  {
                    label: 'Delete scenario',
                    onClick: () => {
                      setNotificationPopup({
                        show: true,
                        status: 'warning',
                        title: 'Delete scenario',
                        buttonText: 'Cancel',
                        buttonStatus: 'success',
                        action: () => {
                          setShowScenarioId(null);
                          setNotificationPopup({ show: false });
                        },
                        buttonText2: 'Delete',
                        buttonStatus2: 'wrong',
                        action2: () => {
                          handleDeleteScenario(showScenarioId);
                          setShowScenarioId(null);
                          setNotificationPopup({ show: false });
                        },
                        text: 'Are you sure you want to delete this scenario?',
                      })
                    },
                    img: deleteIconGray
                  },
                ]}
                onClose={() => setShowScenarioId(null)}
              />
            </div>,
            document.body
          )}

          {showTriggerId.id && createPortal(
            <div
              className="options-container"
              style={{
                position: 'absolute',
                top: menuPosition.top,
                left: menuPosition.left,
                zIndex: 9999,
              }}
            >
              <OptionsMenu
                options={[
                  {
                    label: 'Edit trigger',
                    onClick: () => {
                      setEditMode({ id: showTriggerId.id, status: true });
                      setShowTriggerId({ id: null, type: null });
                    },
                    img: editIconGray
                  },
                  {
                    label: 'Delete trigger',
                    onClick: () => {
                      setNotificationPopup({
                        show: true,
                        status: 'warning',
                        title: 'Delete trigger',
                        buttonText: 'Cancel',
                        buttonStatus: 'success',
                        action: () => {
                          setNotificationPopup({ show: false });
                        },
                        buttonText2: 'Delete',
                        buttonStatus2: 'wrong',
                        action2: () => {
                          handleDeleteTrigger(showTriggerId);
                          setNotificationPopup({ show: false });
                          setShowTriggerId({ id: null, type: null });
                        },
                        text: 'Are you sure you want to delete this trigger?',
                      })
                    },
                    img: deleteIconGray
                  },
                ]}
                onClose={() => setShowTriggerId({ id: null, type: null })}
              />
            </div>,
            document.body
          )}

          <CenteredPopup showPopup={showPopup.state} closePopup={handleClosePopup}>
            {showPopup.state && showPopup.type === "scenario" && (
              <div className="scenario-popup">
                <h4>Create a new notification</h4>
                <div>
                  <div className="scenario-area">
                    <WPLAnimatedInput
                      label="Scenario title"
                      type="text"
                      value={scenarioTitle}
                      onChange={(e) => setScenarioTitle(e.target.value)}
                    />
                  </div>
                  <div className="scenario-area">
                    <WPLAnimatedInput
                      label="Scenario description"
                      type="text"
                      value={scenarioDescription}
                      onChange={(e) => setScenarioDescription(e.target.value)}
                    />
                  </div>
                </div>
                <div className="popup-btn-container">
                  <button
                    disabled={scenarioTitle === ""}
                    onClick={() =>
                      createScenario(scenarioTitle, scenarioDescription)
                    }
                    className="settings-btn"
                  >
                    Create
                  </button>
                </div>
              </div>
            )}
            {showPopup.state && showPopup.type === "lightning-trigger" && (
              <div className="scenario-popup">
                <h4>Create a new notification trigger</h4>
                <p className="trigger-description">
                  Define the trigger for lightning strikes associated with this
                  notification.
                </p>
                <div className="triggers-header"></div>
                <div className="new-triggers-area">
                  <div
                    className={`new-trigger-card ${selectedCard === "inside" ? "selected" : ""
                      }`}
                    onClick={() => handleCardClick("inside")}
                  >
                    <h5>Inside certification (IEC)</h5>
                    <span>
                      <p className="trigger-key">Minimum probability</p>
                      <div className="trigger-span">
                        <input
                          className="trigger-input"
                          value={triggers.inside.min_probability}
                          onChange={handleInputChange}
                          type="number"
                          id="inside"
                          name="min_probability"
                          min="0"
                          max="100"
                          step="1"
                        />
                        <p>%</p>
                      </div>
                    </span>
                    <span>
                      <p className="trigger-key">Max distance</p>
                      <div className="trigger-span">
                        <input
                          className="trigger-input"
                          type="number"
                          id="inside"
                          name="max_distance_km"
                          value={triggers.inside.max_distance_km}
                          onChange={handleInputChange}
                          min="0"
                          step="1"
                        />
                        <p>m</p>
                      </div>
                    </span>
                  </div>

                  <div
                    className={`new-trigger-card ${selectedCard === "outside" ? "selected" : ""
                      }`}
                    onClick={() => handleCardClick("outside")}
                  >
                    <h5>Outside certification (IEC)</h5>
                    <span>
                      <p className="trigger-key">Minimum probability</p>
                      <div className="trigger-span">
                        <input
                          className="trigger-input"
                          value={triggers.outside.min_probability}
                          onChange={handleInputChange}
                          type="number"
                          id="outside"
                          name="min_probability"
                          min="0"
                          max="100"
                          step="1"
                        />
                        <p>%</p>
                      </div>
                    </span>
                    <span>
                      <p className="trigger-key">Max distance</p>
                      <div className="trigger-span">
                        <input
                          className="trigger-input"
                          type="number"
                          id="outside"
                          name="max_distance_km"
                          value={triggers.outside.max_distance_km}
                          onChange={handleInputChange}
                          min="0"
                        />
                        <p>m</p>
                      </div>
                    </span>
                  </div>

                  <div
                    className={`new-trigger-card ${selectedCard === "custom" ? "selected" : ""
                      }`}
                    onClick={() => handleCardClick("custom")}
                  >
                    <span className="custom-title-area">
                      <h5>Custom trigger</h5>
                      {selectedCard === "custom" && (
                        <img
                          src={infoIcon}
                          onClick={() =>
                            window.open("/lassie/support", "_blank")
                          }
                          className="info-icon"
                          alt="Open FAQ section"
                          title="Click here to learn more about these parameters"
                        />
                      )}
                    </span>

                    {selectedCard === "custom" ? (
                      <CustomTriggerForm
                        triggerData={triggers.custom}
                        onTriggerChange={(updatedTrigger) => {
                          setTriggers((prevState) => ({
                            ...prevState,
                            custom: updatedTrigger,
                          }));
                        }}
                        turbineModels={turbineModels}
                      />
                    ) : (
                      <p className="custom-description">
                        Select this option to customize your parameters for lightning activity.
                      </p>
                    )}

                  </div>
                </div>
                {showPopup.trigger_exists ? (
                  <div className="error-area">
                    <p className="error-title">
                      This notification already has active triggers.
                    </p>
                    <p className="error-message">
                      Are you sure you want to create it anyway?
                    </p>
                  </div>
                ) : null}
                <div className="popup-btn-container">
                  <button
                    disabled={
                      selectedCard == null ||
                      (selectedCard === "custom" && (
                        isEmpty(triggers?.custom?.min_probability) ||
                        isEmpty(triggers?.custom?.max_distance_km)
                      ))
                    }
                    onClick={() => handleCreateTrigger()}
                    className="settings-btn"
                  >
                    Create
                  </button>
                </div>
              </div>
            )}

            {showPopup.state && showPopup.type === "action-trigger" &&
              <div className="action-trigger-popup">
                <h4>Create a new action trigger</h4>
                <p className="trigger-description">
                  Define the trigger conditions for user actions associated with this notification.
                </p>
                <div className="action-select-wrapper">
                  <WplSelectInput
                    label="Select type"
                    options={["Uploaded attachment", "Marked for repair", "Inspection scheduled"]}
                    value={selectedActionTrigger === "data_upload" ? "Uploaded attachment" :
                      selectedActionTrigger === "marked_for_repair" ? "Marked for repair" :
                        selectedActionTrigger === "inspection_scheduled" ? "Inspection scheduled" : ""}
                    onChange={(selectedLabel) => {
                      const actionType = selectedLabel === "Uploaded attachment" ? "data_upload" :
                        selectedLabel === "Marked for repair" ? "marked_for_repair" :
                          selectedLabel === "Inspection scheduled" ? "inspection_scheduled" : "";
                      setSelectedActionTrigger(actionType);
                    }}
                    containerClassName="action-type-selector"
                  />
                </div>
                <div className="popup-btn-container">
                  <button
                    disabled={selectedActionTrigger === ''}
                    onClick={() => handleCreateActionCondition(showPopup.scenario_id, selectedActionTrigger)}
                    className="settings-btn"
                  >
                    Create
                  </button>
                </div>
              </div>
            }
          </CenteredPopup>

          <AlertPopup status={notificationPopup.status}
            title={notificationPopup.title}
            showPopup={notificationPopup.show}
            closePopup={() => setNotificationPopup({ show: false })}
            buttonText={notificationPopup.buttonText}
            buttonStatus={notificationPopup.buttonStatus}
            action={notificationPopup.action}
            buttonText2={notificationPopup.buttonText2}
            buttonStatus2={notificationPopup.buttonStatus2}
            action2={notificationPopup.action2}
          >
            {notificationPopup.text}
          </AlertPopup>
        </div>
      )}
    </div>
  );
}
